<div class="layout-footer">
    <span class="font-medium ml-2">Maharaja Soaps (v{{version}})</span>
</div>